export default __webpack_public_path__ + "static/fingerprint-stone-2-ede8a12357b22013adb85410299800fc.jpg";